import { useMemo, useState } from 'react';
import {
  Box,
  Heading,
  Stack,
  Text,
} from '@chakra-ui/react';
import { DedupItemCard, ArtistDropdown } from 'components';
import EmptyState from 'components/EmptyState/EmptyState';
import { useDedupItems } from 'hooks/queries/useDedup';
import { useArtists } from 'hooks/queries/useArtists';
import { ArtistModel } from 'models';

export default function DedupItemOverviewView() {
  const { data: artistsData = [], isLoading: artistsLoading } = useArtists();
  const [selectedArtist, setSelectedArtist] = useState<ArtistModel | null>(null);
  const { data: dedupGroups = [], isLoading } = useDedupItems(selectedArtist?.id);

  const artistOptions = useMemo(() => artistsData, [artistsData]);

  const handleArtistSelect = (artists: ArtistModel[]) => {
    setSelectedArtist(artists[0] || null);
  };

  const noArtistsAvailable = !artistsLoading && artistOptions.length === 0;

  const isEmpty = !isLoading && dedupGroups.length === 0;

  return (
		<Box maxWidth="1200px" width="100%" paddingTop={['80px', '100px', '100px']} justifySelf="center" minHeight="100vh">
      <Heading size="md" mb={6}>Dedup Items</Heading>
      <Box mb={6} maxW="320px">
        <ArtistDropdown
          artists={artistOptions}
          defaultSelectedArtists={selectedArtist ? [selectedArtist] : []}
          onArtistSelect={handleArtistSelect}
          multiSelectable={false}
          maxWidth={true}
        />
      </Box>
      {noArtistsAvailable ? (
        <EmptyState header="No Artists" description="No artists available for deduplication." showButton={false} />
      ) : null}
      {artistsLoading ? (
        <Text color="gray.500" fontSize="sm">Loading artists...</Text>
      ) : null}
      {isLoading ? (
        <Text color="gray.500" fontSize="sm">Loading dedup items...</Text>
      ) : isEmpty ? (
        <EmptyState header="No Dedup Items" description="There are no deduplicated items awaiting review." showButton={false} />
      ) : (
        <Stack spacing={4}>
          {dedupGroups.map((dedupItem) => (
            <DedupItemCard key={dedupItem.id} dedupItem={dedupItem} />
          ))}
        </Stack>
      )}
    </Box>
  );
}
